import type { ValidationErrorBody } from '@app/application/user-management/types'

export const isValidationErrorBody = (
  body: unknown
): body is ValidationErrorBody =>
  typeof body === 'object' &&
  body !== null &&
  'errors' in body &&
  typeof body.errors === 'object' &&
  body.errors !== null
